<template>
  <form class="mt-3">
    <!-- <div class="mb-5">
      <h3>Google Merchant Center Content API Authorization</h3>
      <div class="mb-3">
        See
        <a
          href="https://docs.mpowerpromo.com/space/MP/299827201/Google+Merchant+Center#Setting-up-Content-API"
          target="_blank"
          >Setting up Google Content API</a
        >
        for instructions on how to obtain your merchant id and generate your and Json code.
      </div>


      <validated-input
        :label="'Google Merchant Json'"
        :type="'text-area'"
        v-model="item.googleMerchantJson"
        :help-options="{ content: 'Content API Authentication code generated by Google Merchant Center.' }"
      />
      <b-btn @click="validate" class="mr-2" variant="primary" :disabled="errors.any() || submitted">
        <i class="far fa-spinner-third fa-spin text-white" v-show="submitted"></i>
        Validate the access
      </b-btn>

    </div> -->
    <h3>Product Feeds</h3>
    <validated-input
      :label="'Google Merchant Id'"
      v-model="item.merchantId"
      :help-options="{ content: 'ID of the Google Merchant Center account that products will be published to.' }"
    />
    
    <b-form-group>
      <b-form-checkbox
        id="enable-merchant-reviews"
        v-model="item.enableMerchantReviews"
        name="enable-merchant-reviews"
      >
        Enable Google Customer Reviews
      </b-form-checkbox>
      <small class="form-text text-muted">
        When enabled, customers will be prompted to participate in Google Customer Reviews after completing a purchase.
        This helps build trust with potential customers and can improve your store's visibility.
      </small>
    </b-form-group>
    
    <ProductFeedFile v-if="store.canBuildFeeds" :store="store" />

    <div class="mb-5">
      <h3>Listing Customization</h3>
      <validated-input
        append="%"
        label="Margin"
        :validate="{ decimal: true, minVal: 0, maxVal: 100 }"
        :label="'Google Merchant shipping margin'"
        v-model="item.shippingMargin"
      />
      <p class="text-muted">
        Customize your listings title and description. The following dynamic variables can be used. See
        <a href="https://docs.mpowerpromo.com/space/MP/540999728" target="_blank">Product Feeds</a> for more
        informaiton.
      </p>
      <div class="d-flex mb-3 flex-wrap">
        <span class="badge badge-secondary mr-2 mb-2" v-for="item in dynamicKeys">{{ `\${ ${item} }` }}</span>
      </div>
      <validated-input
        :label="'Product title'"
        :type="'text-area'"
        v-model="item.productTitle"
        placeholder="${productName} with ${facetGroup:material} on ${storeName} is ${random:InStock|OutOfStock}"
      />
      <validated-input :label="'Product description'" :type="'text-area'" v-model="item.productDescription" />

      <ProductFeedLabels :storeData="item" />
      <ProductFeedRules :storeData="item" />

      <ProductsAll
        :url="'/products/all/feeds'"
        :disabled="!item.productTitle && !item.productDescription"
        :query="query"
      >
        <template v-slot:record="propsV1">
          <div class="w-100 d-flex align-items-center border-bottom py-3">
            <div class="col-2">
              <img v-if="propsV1.product.imageDefault" :src="propsV1.product.imageDefault.urlSmall" class="w-100 p-2" />
            </div>
            <div class="col-10">
              <div class="text-left">
                <div>
                  <a href="#" @click="propsV1.toggle">
                    {{ parseValue({ product: propsV1.product, value: item.productTitle, store }) }}
                  </a>
                </div>
                <small>{{ parseValue({ product: propsV1.product, value: item.productDescription, store }) }}</small>
                <div class="mt-3">
                  <btn class="btn btm-sm btn-light" :id="propsV1.product._id" v-if="propsV1.product.feeds?.length">
                    View Data
                  </btn>
                  <b-tooltip :target="propsV1.product._id" custom-class="veryLongTooltip" triggers="hover click">
                    <textarea style="width: 980px; height: 500px">{{
                      JSON.stringify(propsV1.product.feeds, null, 4)
                    }}</textarea>
                  </b-tooltip>
                </div>
              </div>
            </div>
          </div>
        </template>
      </ProductsAll>
    </div>

    <div class="mt-3 d-flex align-items-center">
      <b-btn @click="save" class="mr-2" variant="primary" :disabled="errors.any() || submitted">
        <i class="far fa-spinner-third fa-spin text-white" v-show="submitted"></i>
        Save Feed Settings
      </b-btn>
      <slot :name="'buttons'"></slot>
    </div>
  </form>
</template>
<script>
const dynamicKeys = [
  'productName',
  'productDescription',
  'productId',
  'supplierCode',
  'partName',
  'storeName',
  'facetGroup',
  'random',
  'categoryName',
  'quantity',
  'supplierName',
  'partSize',
  'stockStatus'
];
function escapeRegExp(text) {
  if (!text) return '';
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
function randomInteger(min, max) {
  let rand = min + Math.random() * (max - min);
  return Math.round(rand);
}
function parseValue({ product, value, store }) {
  const keys = [
    {
      key: dynamicKeys[0],
      resource: product
    },
    {
      key: dynamicKeys[2],
      resource: product
    },
    {
      key: dynamicKeys[1],
      orkey: 'description',
      resource: product
    },
    {
      key: dynamicKeys[3],
      resource: product
    },

    {
      key: dynamicKeys[4],
      resource: { [dynamicKeys[4]]: product.partId }
    },
    {
      key: dynamicKeys[5],
      resource: { [dynamicKeys[5]]: store.storeName }
    },
    {
      key: dynamicKeys[8],
      resource: {
        [dynamicKeys[8]]: ((product._category && [product._category]) || product.categories)
          .map((e) => e.name)
          .join(', ')
      }
    },
    {
      key: dynamicKeys[9],
      resource: {
        [dynamicKeys[9]]: product.minQuantity
      }
    },
    {
      key: dynamicKeys[6],
      callback: (value) => {
        try {
          let maxIter = 0;
          const strMatch = '\\\${\\s\{0\,\}facetGroup';
          const regex = new RegExp(strMatch, 'g');
          while (value.match(regex) && maxIter++ < 100) {
            const v = value.split(regex);
            if (v.length < 1) return value;
            const v1 = v[1].split('}');
            let v2 = v1.shift().substr(1);
            const regexMain = new RegExp(strMatch + ':' + escapeRegExp(v2) + '}', 'gi');
            v2 = v2.split(/[\&\|]/gi);
            const facets = product.facets
              .filter((e) =>
                v2.find(
                  (match) =>
                    e.facetGroup.name.match(new RegExp(match, 'gi')) &&
                    (match !== 'color' ||
                      (match === 'color' &&
                        product.colors[0] &&
                        (product.colors[0].name || product.colors[0].color_name || '').toLowerCase().match(e.slug)))
                )
              )
              .map((e) => e.name)
              .filter((e) => e)
              .join(' ');

            value = value.replace(regexMain, facets).trim();
          }

          return value;
        } catch (e) {
          console.log(e);
          return value;
        }
      }
    },
    {
      key: dynamicKeys[7],
      callback: (value) => {
        try {
          let maxIter = 0;
          const strMatch = '\\\${\\s\{0\,\}random';
          const regex = new RegExp(strMatch, 'g');
          while (value.match(regex) && maxIter++ < 100) {
            const v = value.split(regex);
            if (v.length < 1) return value;
            const v1 = v[1].split('}');
            let v2 = v1.shift().substr(1);
            const regexMain = new RegExp(strMatch + ':' + escapeRegExp(v2) + '}', 'gi');
            v2 = v2.split(/[\&\|]/gi);
            v2 = v2[randomInteger(0, v2.length - 1)];

            value = value.replace(regexMain, v2).trim();
          }

          return value;
        } catch (e) {
          console.log(e);
          return value;
        }
      }
    },
    {
      key: dynamicKeys[10],
      resource: {
        [dynamicKeys[10]]: product.supplierId?.name
      }
    },
    {
      key: dynamicKeys[11],
      resource: {
        [dynamicKeys[11]]:
          product.ApparelSize?.label_size ||
          product.specifications
            ?.map((e) => e.specification_type)
            .filter((e) => e)
            .join(',') ||
          ''
      }
    },
    {
      key: dynamicKeys[12],
      resource: {
        [dynamicKeys[12]]: product.inventoryStatus || ''
      }
    }
  ];
  let result = value;
  for (let j = 0; j < keys.length; j++) {
    const item = keys[j];

    if (!item.resource) {
      item.resource = {};
    }

    const el = item.key;
    const patternMatch = el;
    const pattern = `\\\${\\s\{0\,\}${el}\\s\{0\,\}}`;
    const patternValue = item.resource[el] || item.resource[item.orkey] || '';
    const values = value.match(new RegExp(pattern, 'gi'));
    if (values?.length) {
      for (let i = 0; i < values.length; i++) {
        const valueKey = values[i];
        let value = valueKey;
        if (value && valueKey.match(new RegExp(patternMatch, 'gi'))) {
          let _val = patternValue;
          if (item.callback) {
            _val = item.callback(value) || '';
          }
          result = result
            .replace(new RegExp(pattern, 'gi'), _val)
            .replace(/ +(?= )/g, '')
            .replace(/ \./, '.')
            .trim();
          break;
        }
      }
    } else {
      if (item.callback) {
        result = item.callback(result) || '';
      }
    }
  }

  return result;
}
import { api_services } from '../../../../api/api.index';
export default {
  name: 'MerchantCred',
  components: {
    ProductsAll: () => import('../../../ProductsAll'),
    ProductFeedFile: () => import('./ProductFeedFile/ProductFeedFile'),
    ProductFeedLabels: () => import('./Labels'),
    ProductFeedRules: () => import('./Rules')
  },
  props: {
    store: Object,
    storeData: Object
  },
  data() {
    return {
      dynamicKeys,
      item: {
        rules: [],
        labels: [],
        merchantId: '',
        googleMerchantJson: '',
        shippingMargin: 0,
        productDescription: '',
        productTitle: '${productName} with ${facetGroup:material} on ${storeName} is {random:InStock|OutOfStock}'
      },
      submitted: false
    };
  },
  async created() {
    try {
      const data = (await this.$http.get(`/stores/${this.$route.params.storeId}/feed-cred`)).data || {};
      if (!data.suppliersToInclude) data.suppliersToInclude = [];
      if (!data.labels) data.labels = [];
      if (!data.rules) data.rules = [];
      Object.assign(this.item, data);
      Object.assign(this.storeData, this.item);
      if (!this.item.productTitle)
        this.item.productTitle =
          'MPower product {productName} with {facetGroup:material} on {storeName} is {random:InStock|OutOfStock}';
    } catch (e) {
      console.log(e);
    } finally {
      this.$emit('loaded');
    }
  },
  methods: {
    parseValue,
    async save(e) {
      e.preventDefault();
      await this.$validator.validateAll();
      if (this.errors.any()) return;
      
      this.submitted = true;
      try {
        let res;
        if (this.item._id) {
          res = await this.$http.put(
            `/stores/${this.$route.params.storeId}/feed-cred/${this.storeData._id}`,
            this.item
          );
        } else {
          res = await this.$http.post(`/stores/${this.$route.params.storeId}/feed-cred`, this.storeData);
        }

        Object.assign(this.item, res.data);
        Object.assign(this.storeData, this.item);
        this.notifySuccess('Feed Credentials Saved');
      } catch (e) {
        this.notifyError(e.message || e);
      } finally {
        this.submitted = false;
      }
    },
    async validate(e) {
      e.preventDefault();
      await this.$validator.validateAll();
      if (this.errors.any()) return;

      this.submitted = true;
      try {
        const res = (await api_services().post(`/stores/${this.$route.params.storeId}/validate-feeds`, this.item)).data;
        if (!res.status) {
          throw 'Not valid';
        }
        this.notifySuccess('Feed Credentials valid');
      } catch (e) {
        this.notifyError(e.data?.message || e.message || e);
      } finally {
        this.submitted = false;
      }
    }
  },
  computed: {
    query() {
      const facetGroups =
        this.item.labels
          .map((e) => e.facetGroups.map((e) => e._id || e))
          .reduce((a, b) => [...a, ...b], [])
          .join('_') || '';
      return `status=active&storeId=${
        this.$route.params.storeId
      }&withFacets=1&withCategories=1&withSupplier=1&top25=1&previewFeeds=1${
        facetGroups && `&facetGroups=${facetGroups}`
      }`;
    }
  }
};
</script>
<style>
.veryLongTooltip .tooltip-inner {
  max-width: 100%;
}
</style>
